import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {Navigation, Pagination, Autoplay} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperItem from "./SwiperItem";
import ContextMenu from "../TabsComponent/ContextMenu";
import {uid} from "react-uid";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import TabContainer from "../TabsComponent/TabContainer";
import {useSelector} from "react-redux"; // core Swiper
import './my-swiper.css'
const initialContextState = {
    mouseX: null,
    mouseY: null,
};
const SwiperComponent = props => {
    const {component, path, index} = props;
    const {properties = {}, children = [{}]} = component;
    const {
        onDeleteComponent,
        onSelectComponent,
        onDropComponent
    } = useContext(ScreenDesignerContextNew);
    const [anchorEl, setAnchorEl] = useState(initialContextState);
    const [editSwipe, setEditSwipe] = useState({index: null, source: null});
    const {appEnv} = useSelector(state => state.app)

    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return '<div ' + '' +
                'style="width: 50px; height: 4px !important; border-radius: 0; font-size: 0; background: #d3d3d3;" ' +
                'class="myPagination ' + className + '">' + (index + 1) + "</div>";
        }
    }

    function openTabContext(event, source, index) {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
        });
        setEditSwipe({index, source})
    }

    function onEdit() {
        onSelectComponent(editSwipe.source, `${path}.children.${editSwipe.index}`)
    }

    function addAfter() {
        onDropComponent({type: 'swiperItem'}, editSwipe.index + 1, `${path}.children`)
    }

    function addBefore() {
        onDropComponent({type: 'swiperItem'}, editSwipe.index, `${path}.children`)
    }

    function onRemove() {
        console.log(editSwipe)
        onDeleteComponent(`${path}.children.${editSwipe.index}`, editSwipe.source.type)
    }

    function duplicate() {
        onDropComponent(editSwipe.source, editSwipe.index + 1, `${path}.children`)
    }

    function onCloseContext() {
        setAnchorEl(initialContextState);
        setEditSwipe({index: null, source: null})
    }

    return (
        <div style={{width: '100%', height: '100%'}}>
            {properties.type === 'carousel' ? (
                <Swiper
                    pagination={pagination}
                    modules={[Pagination]}
                    style={{
                        height: '100%'
                    }}
                >
                    {children.map((swipeItem, index) => {
                        const {styles: sourceStyles} = swipeItem;
                        const styles = sourceStyles ? sourceStyles[0] : {};
                        const backgroundImagePublicUrl = styles.backgroundImage ? process.env.NODE_ENV === 'development' ?
                            `${process.env.REACT_APP_REMOTE_HOST}${appEnv}${styles.backgroundImage.url}` :
                            `/${appEnv}` + styles.backgroundImage.url : '';

                        return (
                            <SwiperSlide key={uid(swipeItem)}
                                         style={{
                                             width: '100%',
                                             height: '100%',
                                             display: 'flex',
                                             flexDirection: 'column',
                                             justifyContent: styles.justifyContent,
                                             alignItems: styles.alignItems,
                                             backgroundL: styles.background,
                                             backgroundImage: `url(${backgroundImagePublicUrl})`
                                         }}
                                         onClick={(e) => {
                                             e.stopPropagation();
                                             setEditSwipe({index, swipeItem})
                                             onSelectComponent(swipeItem,`${path}.children.${index}`)
                                         }}
                                         onContextMenu={(e) => {
                                             openTabContext(e, swipeItem, index)
                                         }}

                            >
                                <TabContainer
                                    path={path}
                                    component={swipeItem}
                                    index={index}
                                />
                            </SwiperSlide>
                        )
                    })}

                </Swiper>
            ) : (
                <SwiperItem
                    component={component.children[0]}
                    path={`${path}.children.0`}
                    index={index}
                />
            )}
            <ContextMenu
                anchorEl={anchorEl}
                onClose={onCloseContext}
                duplicateItem={duplicate}
                addAfter={addAfter}
                addBefore={addBefore}
                edit={onEdit}
                remove={onRemove}
                index={editSwipe.index}
                itemsCount={children.length}
            />
        </div>
    );
};

SwiperComponent.propTypes = {
    component: PropTypes.object,
    path: PropTypes.string
};

export default SwiperComponent;